export default __webpack_public_path__ + "locales/it/People.json?hash=9dfc5ddef9a42e4778bad276c559d6ca";